import React, {useRef, useEffect} from "react";
import ReactPixel from 'react-facebook-pixel';
import { useNavigate } from "react-router-dom";
import MenuBar from "../UI/Menu/Menu";
import "./Home.css";
import { useSelector, useDispatch } from "react-redux";
import { setMessages, setUser, setProfileImg, setUserFirstName } from "../../redux/states";
import { checkAuthenticatedUser } from "../../utils/client-functions";

import axios from "axios";
import FreeTrial from "../UI/FreeTrial/FreeTrial";
import MainBanner from "./MainBanner";
import HomeActionSection from "./HomeActionSection";
import Offers from "../UI/Offers/Offers";
import SchoolsCTABannerV2 from "../UI/SchoolsCTABanner/SchoolsCTABannerV2";
import Companies from "../UI/TopCompanies/Companies";
import Testimonials from "../UI/Testimonials/Testimonial";
import AppAd from "../UI/AppAd/AppAd";
import SubscriptionPlans from "../UI/SubscriptionPlans/Subscriptions";
import FAQ from "../UI/FAQ/FAQ";
import Footer from "../UI/Footer/Footer";
import bubblesvg from "../../images/Bubble.svg"
import BubbleFloat from "../UI/BubbleFloat/BubbleFloat";
import { useErrorSetter } from '../../hooks/useUiMessages';
import analyticsTracker from "../../utils/analytics";



const Home = () => {
  const { user} = useSelector((state) => state.stateData);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isEffectExecuted = useRef(false);
  useEffect(() => {
    const pageHeight = document.body.scrollHeight - window.innerHeight;
    document.documentElement.style.setProperty('--page-height', `${pageHeight}px`);
  }, []);


  const errorSetter = useErrorSetter();


  const isAuth = localStorage?.getItem("token");

  useEffect(() => {
    ReactPixel.init('1133510054551065');
    ReactPixel.pageView();
  }, []);

  // Smooth scroll to hashed section on load or hash change
  useEffect(() => {
    const scrollToHash = () => {
      const hash = window.location.hash?.replace('#', '');
      if (!hash) return;
      const el = document.getElementById(hash);
      if (el) {
        try {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (_) {
          const top = el.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }
    };
    // Scroll on mount if there's a hash
    scrollToHash();
    // And when hash changes
    window.addEventListener('hashchange', scrollToHash);
    return () => window.removeEventListener('hashchange', scrollToHash);
  }, []);

  //fetch messages for auth user
  useEffect(() => {
    const populateUser = async () => {
      if (isAuth) {
        //only try this if isAuth present in local Storage, meaning user had previously logged into browser
        try {
          //must await
          await checkAuthenticatedUser()
        } catch (error) {
          return navigate("/popin");      
        }

        try {
          const headers = {
            "x-access-token": isAuth,
          };
          const response = await axios.get("/user/user", { headers });
          if (response.data.status === "unauthenticated" || response.data.status === "Unauthorized") {
            localStorage?.removeItem("token");
            return navigate("/popin");
          }

          dispatch(setProfileImg(response.data.user.profileImg));
          dispatch(setUserFirstName(response.data.user.firstName));
          // Fetch messages from new endpoint backed by MessageThread collection
          try {
            const m = await axios.get('/user/messages', { headers });
            const arr = Array.isArray(m?.data?.messages) ? m.data.messages : [];
            if (arr.length > 0) dispatch(setMessages(arr[arr.length - 1]));
            // dispatch(setAllMessagesArray(arr));
          } catch(_) {}
          dispatch(setUser(response.data.user));
        } catch (error) {
          errorSetter("Reload page to fetch data");
        }
      } else {
        //console.log("unauthenticated");
      }
    };

    if (!isEffectExecuted.current) {
      populateUser();
      isEffectExecuted.current = true;
    }
  }, [dispatch, user, navigate, isAuth, errorSetter]);



  const handleFocus = () => {
    try { analyticsTracker.trackServiceClick('Search', '/chat'); } catch (e) { /* noop */ }
    localStorage.setItem('woot', true)
    navigate("/chat")
  };



  return (
    <div>
      <BubbleFloat>
        <img src={bubblesvg} alt="bubble asset floating"/>
      </BubbleFloat>
        <div style={{position: 'relative', zIndex: 1}}>
            <MenuBar />

          <div className="pageContent">
                {!isAuth && (
                  <FreeTrial />
                )}

                <MainBanner isAuth={isAuth} start={handleFocus} />

                <HomeActionSection isAuth={isAuth} />

                <Offers isAuth={isAuth} />

                <SchoolsCTABannerV2 />

                <Testimonials />

                <AppAd />

                <Companies />

                <div id="pricing">
                  <SubscriptionPlans/>
                </div>

                <FAQ/>

                <Footer/>
          </div>


      </div>

    </div>
  );
};

export default Home;